import type { CrmObjectTypeSchema } from '@/lib/crm/core/SchemaClient';
import { getTypeLabelByName } from '@/lib/crm/utils/getTypeLabel';

/**
 * Static labels for the core system record types. Kept for callers that need a
 * synchronous map; prefer {@link getEntityTypeLabel} for anything that may
 * encounter a custom (`org_*`) entity type.
 */
export const ENTITY_TYPE_LABELS: Record<string, string> = {
  ahoy_contact: 'Contact',
  ahoy_company: 'Company',
  ahoy_deal: 'Deal',
  ahoy_note: 'Note',
};

/**
 * Resolve the human-readable label for any importable entity type — including
 * custom `org_*` types. Delegates to the canonical {@link getTypeLabelByName}
 * helper, which resolves (in order): the org admin's chosen schema label when
 * `objectTypes` is supplied, the built-in registry, then a snake_case→Title Case
 * fallback (so `org_workspace_user` → "Workspace User" even without schema).
 */
export function getEntityTypeLabel(
  entityTypeName: string,
  objectTypes: CrmObjectTypeSchema[] = []
): string {
  return getTypeLabelByName(entityTypeName, {}, objectTypes);
}
